import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@mui/material/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import PolicyAcceptanceModal from '../../components/PolicyAcceptanceModal';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const isWalkThrough = pathname.includes('walkthrough');
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <PolicyAcceptanceModal />
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      {!isWalkThrough && <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />}
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
